import { BarChart3, FileText, Languages, Lightbulb } from "lucide-react";
import type { Language } from "../types";
import { copy } from "../data/survey";
import { pikbCopy } from "../data/pikb";

type Props = {
  language: Language;
  path: string;
  navigate: (path: string) => void;
  setLanguage: (language: Language) => void;
  showNavigation?: boolean;
};

const navItems = [
  {
    path: "/putatan",
    match: (path: string) => path.startsWith("/putatan"),
    icon: FileText,
    label: (language: Language) => (language === "ms" ? "Putatan" : "Putatan"),
  },
  {
    path: "/pikb",
    match: (path: string) => path.startsWith("/pikb"),
    icon: Lightbulb,
    label: (language: Language) => pikbCopy.shortName[language],
  },
  {
    path: "/dashboard",
    match: (path: string) => path.startsWith("/dashboard"),
    icon: BarChart3,
    label: (language: Language) => copy.dashboard[language],
  },
];

export function AppHeader({
  language,
  path,
  navigate,
  setLanguage,
  showNavigation = true,
}: Props) {
  const isPikb = path.startsWith("/pikb");
  const currentAppName = isPikb ? pikbCopy.appName[language] : copy.appName[language];
  const currentContext = isPikb ? "PIKB 2026" : "Putatan Survey";
  const brandTarget = isPikb ? "/pikb" : "/putatan";

  return (
    <header className="topbar">
      <button
        className="brand-button"
        type="button"
        onClick={() => navigate(brandTarget)}
        aria-label={currentAppName}
      >
        <span className={`brand-mark ${isPikb ? "brand-mark-pikb" : ""}`}>
          {isPikb ? "I" : "P"}
        </span>
        <span className="brand-copy">
          <strong>{currentAppName}</strong>
          <small>{currentContext}</small>
        </span>
      </button>

      <nav className="topbar-actions" aria-label="Primary navigation">
        {showNavigation
          ? navItems.map((item) => {
              const Icon = item.icon;
              const active = item.match(path);

              return (
                <button
                  className={`nav-pill ${active ? "is-active" : ""}`}
                  type="button"
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  aria-current={active ? "page" : undefined}
                >
                  <Icon size={17} />
                  <span>{item.label(language)}</span>
                </button>
              );
            })
          : null}

        <button
          className="icon-pill"
          type="button"
          onClick={() => setLanguage(language === "ms" ? "en" : "ms")}
          title="Switch language"
          aria-label="Switch language"
        >
          <Languages size={18} />
          <span>{language === "ms" ? "BM" : "EN"}</span>
        </button>
      </nav>
    </header>
  );
}
